// Static legal copy — displayed in ConsentModal, /terms, /privacy.
// Keep TOS_VERSION and PRIVACY_VERSION in sync with backend server.py.

export const TOS_VERSION = "2026-02-19";
export const PRIVACY_VERSION = "2026-02-20";

export const TERMS_SECTIONS = [
  {
    title: "1. What LinguaSub does",
    body: "LinguaSub is a tool that transcribes and translates audio, video, or pasted text you provide. We do not seek out, host, or redistribute content — we act as a technical pipeline over the material you upload.",
  },
  {
    title: "2. You must have rights to what you upload",
    body: "You represent and warrant that you own, or have permission from the rightful owner to process, the audio, video, or text you submit. Uploading copyrighted movies, songs, broadcasts, or other third-party works without authorisation is prohibited and remains solely your responsibility.",
  },
  {
    title: "3. Ownership of your output",
    body: "The transcripts, translations, and subtitle files (SRT/VTT) produced from your input belong to you. Note that they may still be derivative works of the source material, and any downstream rights (redistribution, publishing, monetisation) depend on your rights to the underlying content.",
  },
  {
    title: "4. Acceptable use",
    body: "You will not use LinguaSub to infringe intellectual property, defame others, produce hateful or unlawful content, or bypass our rate limits and security measures. We may suspend accounts that repeatedly violate these terms.",
  },
  {
    title: "5. Third-party AI providers",
    body: "Your input is transmitted to OpenAI (Whisper for transcription; GPT-5.4 for translation) via the Emergent Universal Key. Their terms and privacy practices apply during processing. We do not train models on your content.",
  },
  {
    title: "6. Indemnity",
    body: "You will indemnify and hold LinguaSub harmless from third-party claims arising out of content you submitted or the way you used the output.",
  },
  {
    title: "7. No warranty",
    body: "The service is provided \"as is\". Machine transcription and translation are imperfect and may miss dialects, misspell names, or misinterpret idioms. Review the output before publishing.",
  },
  {
    title: "8. Takedown",
    body: "If you believe content processed on LinguaSub infringes your rights, submit a takedown at /takedown. We investigate and act on valid complaints promptly.",
  },
  {
    title: "9. Changes",
    body: `These terms are versioned. Current version: ${TOS_VERSION}. When we make material changes we will ask you to re-accept the new version before continuing to use the app.`,
  },
];

export const PRIVACY_SECTIONS = [
  {
    title: "What we collect",
    body: "Your account details (email, name, and, for Google sign-in, profile picture), the input you submit, the generated transcripts and translations, and your feedback comments.",
  },
  {
    title: "How we use it",
    body: "To transcribe and translate your input, show your job history, populate the feedback wall, and improve the product. We never sell your data.",
  },
  {
    title: "Uploaded media retention",
    body: "Video and audio you upload are stored on our servers for up to 48 hours after processing so you can edit the subtitles against the video and export a subtitled video file. After 48 hours the original media is deleted automatically. Text you paste is never stored beyond the resulting SRT/VTT. You can also delete a job manually at any time.",
  },
  {
    title: "Third parties that process your data",
    body: "OpenAI Whisper (transcription) and GPT-5.4 (translation) via the Emergent Universal Key. Google (only if you sign in with Google Auth).",
  },
  {
    title: "Cookies",
    body: "We store one httpOnly session cookie (session_token) to keep you signed in for 7 days. We do not use tracking cookies.",
  },
  {
    title: "Your rights",
    body: "You can delete your account, download your job history, or ask for full erasure by writing to privacy@linguasub.dev. We honour valid requests within 30 days.",
  },
  {
    title: "Changes",
    body: `Current version: ${PRIVACY_VERSION}. We ask you to re-accept the policy when we make material changes.`,
  },
];
